
"use strict";
(function () {

// Detect mobile device (Do not remove!!!)
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Nokia|Opera Mini/i.test(navigator.userAgent) ? true : false;
if (isMobile) {
    document.body.classList.add("is-mobile");
}


// Page Loader
window.addEventListener("load", function () {
    setTimeout(function () {
        const pageLoader = document.querySelector(".page-loader");
        if (pageLoader) {
            pageLoader.style.transition = "opacity 0.8s ease";
            pageLoader.style.opacity = "0";

            setTimeout(function () {
                pageLoader.style.display = "none";
            }, 800);
        }

    }, 800);
    gsap.to(".bar", 1.5, {
        delay: 0,
        height: 0,
        stagger: {
            amount: 0.5
        },
        ease: "power4.inOut"
    });
});


// swiper slider
// var logoSlider = document.querySelector('.swiper-logo-slider');
// if(logoSlider) {
//     var swiperOptions = {
//         direction: 'horizontal',
//         loop: true,
//         autoplay: {
//             delay: 5000,
//             disableOnInteraction: false
//         },
//         slidesPerView: 'auto',
//         speed: 6000,
//         grabCursor: true,
//         allowTouchMove: true,
//     };
//     var swiper = new Swiper(".swiper-logo-slider", swiperOptions);
// }

var quotesSlider = document.querySelector('.quotes-slider');
if(quotesSlider) {
    var swiperOptions2 = {
         slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        }
    };
    var swiper = new Swiper(".quotes-slider", swiperOptions2);
}
var quotesSlider = document.querySelector('.quotes-slider-two');
if(quotesSlider) {
    var swiperOptions2 = {
        slidesPerView: '1',
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        }
    };
    var swiper = new Swiper(".quotes-slider-two", swiperOptions2);
}


var carousel_main = document.querySelector('.carousel_main');
if(carousel_main) {
    var swiperOptions3 = {
        effect: "coverflow",
        grabCursor: true,
        slidesPerView: 3,
        spaceBetween: 50,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 3,
            slideShadows: true
        },
        loop: true,
        // navigation: {
        //     nextEl: '.swiper-button-next2',
        //     prevEl: '.swiper-button-prev2',
        // },
        pagination: {
            el: ".swiper-pagination2",
            clickable: true
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 2
            },
            1560: {
                slidesPerView: 3
            }
        }
    };
    var swiper = new Swiper(".carousel_main", swiperOptions3);
}



// Image parallax
var imageParallax = document.querySelectorAll(".parallax-image");
if (imageParallax.length > 0) {
    imageParallax.forEach(function (element) {
        // Add wrap <div>.
        var parallaxImageWrap = document.createElement("div");
        parallaxImageWrap.classList.add("parallax-image-wrap");

        var parallaxImageInner = document.createElement("div");
        parallaxImageInner.classList.add("parallax-image-inner");

        element.parentNode.insertBefore(parallaxImageWrap, element);
        parallaxImageWrap.appendChild(parallaxImageInner);
        parallaxImageInner.appendChild(element);

        // Add overflow hidden.
        parallaxImageWrap.style.overflow = "hidden";

        var animImageParallax = element;
        var aipWrap = animImageParallax.closest(".parallax-image-wrap");
        var aipInner = aipWrap.querySelector(".parallax-image-inner");

        var tl_ImageParallax = gsap.timeline({
            scrollTrigger: {
                trigger: aipWrap,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onEnter: animImgParallaxRefresh
            }
        });
        tl_ImageParallax.to(animImageParallax, { yPercent: 30, ease: "none" });

        function animImgParallaxRefresh() {
            tl_ImageParallax.scrollTrigger.refresh();
        }

        // Zoom in
        var tl_aipZoomIn = gsap.timeline({
            scrollTrigger: {
                trigger: aipWrap,
                start: "top 99%"
            }
        });
        tl_aipZoomIn.from(aipInner, { duration: 1, autoAlpha: 0, scale: 1.2, ease: "power2.out", clearProps: "all" });
    });
}









// Smooth scroll

// const isTouchDevice = 'ontouchstart' in document.documentElement;

// disableScroll();
// if (!isTouchDevice) smoothScroll();

// window.onresize = () => {
//   resizeBodyHeight();
// };

// window.onload = () => {
//   enableScroll();
//   resizeBodyHeight();
// };

// // Functions
// function disableScroll() {
//   document.body.style.overflow = 'hidden';
// }
// function enableScroll() {
//   document.body.style.overflow = '';
// }
// function smoothScroll() {
//   document.querySelector('.viewport').classList.add('SmoothScroll');
//   new SmoothScroll({
//     target: document.querySelector('.smoothscroll-inr'),
//     scrollEase: 0.1,
//     maxOffset: 500,
//   });
// }
// function resizeBodyHeight() {
//   document.body.style.height = document.querySelector('.viewport').scrollHeight + 'px';
// }







// Magic cursor (no effect on small screens!)
if (!document.body.classList.contains("is-mobile")) {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".follower");
    const cursorScale = document.querySelectorAll(".cursor-scale");
    
    document.addEventListener("pointermove", function (e) {
        positionCircle(e);
    });

    function positionCircle(e) {
        let relX = e.clientX;
        let relY = e.clientY;
        TweenMax.from(cursor, 0.3, { x: relX - 0, y: relY - 0 });
        TweenMax.to(follower, 0.3, { x: relX - 21, y: relY - 21 });
    }
    const cursorPlay = document.querySelectorAll(".cursor-play");
    cursorPlay.forEach((cursorPlay) => {
        cursorPlay.addEventListener("mouseenter", function () {
            document.querySelector(".cursor").classList.add("cursor-play");
            document.querySelector(".cursor-play").classList.remove("cursor-drag");
        });

        cursorPlay.addEventListener("mouseleave", function () {
            document.querySelector(".cursor").classList.remove("cursor-play");
        });
    });
    const cursorDrag = document.querySelectorAll(".swiper-container, .quotes-wrapper");
    cursorDrag.forEach((cursorDrag) => {
        cursorDrag.addEventListener("mouseenter", function () {
            document.querySelector(".cursor").classList.add("cursor-drag");
        });

        cursorDrag.addEventListener("mouseleave", function () {
            document.querySelector(".cursor").classList.remove("cursor-drag");
        });
    });

    const cursorClose = document.querySelectorAll(".overlay:not(.image-wrapper .overlay)");
    cursorClose.forEach((cursorClose) => {
      cursorClose.addEventListener("mouseenter", function () {
        document.querySelector(".cursor").classList.add("cursor-close");
      });

      cursorClose.addEventListener("mouseleave", function () {
        document.querySelector(".cursor").classList.remove("cursor-close");
      });
    });

} else {
    const cursor = document.querySelector(".cursor");
    const follower = document.querySelector(".follower");
    if (cursor) cursor.remove();
    if (follower) follower.remove();
}



if (!document.body.classList.contains("is-mobile")) {

    //PARALLAX ITEM
    // Wrapping elements with the class "parallax-item"
    var parallaxItems = document.querySelectorAll(".parallax-item");
    parallaxItems.forEach(function (item) {
        var itemWrap = document.createElement("div");
        itemWrap.classList.add("parallax-item-wrap");
        item.parentNode.insertBefore(itemWrap, item);
        itemWrap.appendChild(item);
    });

    // Get all the wrapped items
    var itemWraps = document.querySelectorAll(".parallax-item-wrap");

    // The calcValue function
    function calcValue(value, inputMax, inputMin, outputMax, outputMin) {
        var percent = (value - inputMin) / (inputMax - inputMin);
        var output = percent * (outputMax - outputMin) + outputMin;
        return output;
    }

    // Adding event listeners to each wrapped item
    itemWraps.forEach(function (itemWrap) {
        var item = itemWrap.querySelector(".parallax-item");
        itemWrap.addEventListener("mousemove", function (e) {
            var mouseX = e.clientX;
            var mouseY = e.clientY;
            var rect = itemWrap.getBoundingClientRect();
            var offsetX = rect.left + rect.width / 2;
            var offsetY = rect.top + rect.height / 2;
            var deltaX = mouseX - offsetX;
            var deltaY = mouseY - offsetY;
            var percentX = deltaX / (itemWrap.clientWidth / 2);
            var percentY = deltaY / (itemWrap.clientHeight / 2);

            item.style.transform = `
                translateX(${calcValue(percentX, 1, -1, 20, -20)}px) 
                translateY(${calcValue(percentY, 1, -1, 20, -20)}px) 
                rotateX(${calcValue(percentY, 1, -1, 5, -5)}deg) 
                rotateY(${calcValue(percentX, 1, -1, -5, 5)}deg)
            `;
        });

        itemWrap.addEventListener("mouseleave", function () {
            item.style.transform = "translateX(0) translateY(0) rotateX(0) rotateY(0)";
        });
    });
}






//GSAP scrollTrigger
gsap.registerPlugin(ScrollTrigger);

var brandlinkLogo = function() {
    var e = document.querySelectorAll(".swiper-wrapper");
    e && e.length && e.forEach((function(e) {
        ! function(e) {
            var t = e.querySelectorAll(".brand-link_logo"),
                r = 0.5;
            t && t.length && t.forEach((function(t) {
                gsap.set(t, {
                    opacity: 0,
                    y: 20
                }), gsap.to(t, {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    delay: r,
                    ease: "power1.out",
                    scrollTrigger: {
                        trigger: e,
                        start: "top center+=500"
                    }
                }), r += .1
            }))
        }(e)
    }))
};

window.addEventListener("load", function () {
    brandlinkLogo();
});

let animationRotate = document.querySelectorAll(".animation-rotate");
animationRotate.forEach((animationRotate) => {
    gsap.to(animationRotate, {
        duration: 2,
        rotation: 360,
        ease: "linear",
        repeat: -1
    });
});

let scrollRotate = document.querySelectorAll(".scroll-rotate");
scrollRotate.forEach((scrollRotate) => {
    gsap.to(scrollRotate, {
        scrollTrigger: {
            trigger: scrollRotate,
            scrub: 2
        },
        rotation: 720
    });
});

let scrollMoveRight = document.querySelectorAll(".scroll-move-right");
scrollMoveRight.forEach((scrollMoveRight) => {
    gsap.to(scrollMoveRight, {
        x: 500,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRight,
            start: "top 30%",
            scrub: 2
        }
    });
});

let scrollMoveLeft = document.querySelectorAll(".scroll-move-left");
scrollMoveLeft.forEach((scrollMoveLeft) => {
    gsap.to(scrollMoveLeft, {
        x: -500,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeft,
            start: "top 30%",
            scrub: 2
        }
    });
});

let scrollMoveRightLarge = document.querySelectorAll(".scroll-move-rightlarge");
scrollMoveRightLarge.forEach((scrollMoveRightLarge) => {
    gsap.to(scrollMoveRightLarge, {
        x: 700,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRightLarge,
            start: "top bottom",
            scrub: 2
        }
    });
});

let scrollMoveLeftLarge = document.querySelectorAll(".scroll-move-leftlarge");
scrollMoveLeftLarge.forEach((scrollMoveLeftLarge) => {
    gsap.to(scrollMoveLeftLarge, {
        x: -700,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeftLarge,
            start: "top bottom",
            scrub: 2
        }
    });
});


let scrollMoveRight2 = document.querySelectorAll(".scroll-move-right2");
scrollMoveRight2.forEach((scrollMoveRight2) => {
    gsap.to(scrollMoveRight2, {
        x: 800,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveRight2,
            start: "top 100%",
            scrub: 2
        }
    });
});

let scrollMoveLeft2 = document.querySelectorAll(".scroll-move-left2");
scrollMoveLeft2.forEach((scrollMoveLeft2) => {
    gsap.to(scrollMoveLeft2, {
        x: -400,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveLeft2,
            start: "top 100%",
            scrub: 2
        }
    });
});

let scrollMoveUp = document.querySelectorAll(".scroll-move-up");
scrollMoveUp.forEach((scrollMoveUp) => {
    gsap.to(scrollMoveUp, {
        y: -400,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUp,
            start: "top 20%",
            scrub: 2
        }
    });
});



let scrollMoveUpLarge = document.querySelectorAll(".scroll-move-uplarge");
scrollMoveUpLarge.forEach((scrollMoveUpLarge) => {
    gsap.to(scrollMoveUpLarge, {
        y: -800,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUpLarge,
            start: "top 20%",
            scrub: 2
        }
    });
});

let scrollMoveDownLarge = document.querySelectorAll(".scroll-move-downlarge");
scrollMoveDownLarge.forEach((scrollMoveDownLarge) => {
    gsap.to(scrollMoveDownLarge, {
        y: 1000,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveDownLarge,
            start: "top 20%",
            scrub: 2
        }
    });
});



let growUp = document.querySelectorAll(".grow-up");
growUp.forEach((growUp) => {
    gsap.fromTo(
        growUp,
        {
            autoAlpha: 0.5,
            scale: 0.7
        },
        {
            autoAlpha: 1,
            duration: 2,
            scale: 1,
            scrollTrigger: {
                trigger: growUp,
                start: "top 90%"
            },
            stagger: 0.2
        }
    );
});

let scrollZoomIn = document.querySelectorAll(".scroll-zoom-in");
scrollZoomIn.forEach((scrollZoomIn) => {
    gsap.to(scrollZoomIn, {
        scrollTrigger: {
            trigger: scrollZoomIn,
            start: "top 10%",
            scrub: 2
        },
        scale: 1.5
    });
});

let scrollZoomIn2 = document.querySelectorAll(".scroll-zoom-in-2");
scrollZoomIn2.forEach((scrollZoomIn2) => {
    gsap.to(scrollZoomIn2, {
        scrollTrigger: {
            trigger: scrollZoomIn2,
            start: "top 90%",
            scrub: 2
        },
        scale: 1
    });
});

let scrollZoomOut = document.querySelectorAll(".scroll-zoom-out");
scrollZoomOut.forEach((scrollZoomOut) => {
    gsap.to(scrollZoomOut, {
        scrollTrigger: {
            trigger: scrollZoomOut,
            start: "top 15%",
            scrub: 2
        },
        scale: 0.8
    });
});

let revealContainers = document.querySelectorAll(".reveal-img");
revealContainers.forEach((revealContainers) => {
    let image = revealContainers.querySelector("img");
    let tl4 = gsap.timeline({
        scrollTrigger: {
            trigger: revealContainers,
            toggleActions: "restart none none reset"
        }
    });

    tl4.set(revealContainers, { autoAlpha: 1 });
    tl4.from(revealContainers, 1.5, {
        xPercent: -100,
        ease: Power2.out
    });
    tl4.from(image, 1.5, {
        xPercent: 100,
        scale: 1.3,
        delay: -1.5,
        ease: Power2.out
    });
});


//TEXT-UP
// if (window.innerWidth > 500) {
    var textUpElements = document.querySelectorAll(".text-up");
    textUpElements.forEach(function (element) {
        var revealTextCover = document.createElement("div");
        revealTextCover.classList.add("reveal-text-cover");
        
        var revealText = document.createElement("div");
        revealText.classList.add("reveal-text");
        
        revealTextCover.appendChild(revealText);
        element.parentNode.insertBefore(revealTextCover, element);
        revealText.appendChild(element);
    });
// }


const revealTexts = document.querySelectorAll(".reveal-text");
revealTexts.forEach((revealText) => {
    gsap.set(revealText, { y: 120, opacity: 0 });
    gsap.to(revealText, {
        duration: 1,
        y: 0,
        opacity: 1,
        ease: Power3.easeOut,
        scrollTrigger: {
            trigger: revealText,
            start: "top 100%",
            end: "top 0%",
            toggleActions: "play none none reverse"
        }
    });
});


//FADEIN-UP
const fadeInUp = document.querySelectorAll(".fadeInUp");
fadeInUp.forEach((fadeInUp) => {
    gsap.fromTo(
        fadeInUp,
        {
            opacity: 0,
            scale: 0.8,
            y: 150
        },
        {
            opacity: 1,
            duration: 1.5,
            scale: 1,
            y: 0
        }
    );
});

let scrollMoveUp2 = document.querySelectorAll(".scroll-move-up-2");
scrollMoveUp2.forEach((scrollMoveUp2) => {
    gsap.to(scrollMoveUp2, {
        y: -40,
        duration: 1.5,
        scrollTrigger: {
            trigger: scrollMoveUp2,
            start: "top 70%",
            scrub: 2
        }
    });
});

let scrollMoveUp3 = document.querySelectorAll(".scroll-move-up-3");
scrollMoveUp3.forEach((scrollMoveUp3) => {
    gsap.to(scrollMoveUp3, {
        y: -80,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp3,
            start: "top 70%",
            scrub: 2
        }
    });
});

let scrollMoveUp4 = document.querySelectorAll(".scroll-move-up-4");
scrollMoveUp4.forEach((scrollMoveUp4) => {
    gsap.to(scrollMoveUp4, {
        y: -70,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp4,
            start: "top 70%",
            scrub: 2
        }
    });
});


  const mediaQuery = window.matchMedia('(max-width: 991px)')
if (mediaQuery.matches) {

  let scrollMoveUp4 = document.querySelectorAll(".scroll-move-up-4");
  scrollMoveUp4.forEach((scrollMoveUp4) => {
    gsap.to(scrollMoveUp4, {
        y: -40,
        duration: 2,
        scrollTrigger: {
            trigger: scrollMoveUp4,
            start: "top 70%",
            scrub: 2
        }
    });
  });

}

  // ---- Calculate Price Popup ----

  function calculatePricePopup() {
    setTimeout(function () {
      const popupClosedDate = localStorage.getItem("popup_closed");
      const subscribed = localStorage.getItem("subscribed");

      if (!subscribed && (!popupClosedDate || new Date() > new Date(popupClosedDate))) {
        const popup = document.querySelector(".price-popup .calculate-price-popup-main");
        const popupWrapper = document.querySelector(".price-popup.calculate-price-popup");

        if (popup) {
          popup.style.opacity = "0";
          popup.style.display = "block";
          popupWrapper.classList.add("active");

          setTimeout(() => {
            popup.style.opacity = "1";
          }, 200);
        }
      }
    }, 6000);

    const closeButton = document.querySelector(".close-popup");
    if (closeButton) {
      closeButton.addEventListener("click", function () {
        const popup = document.querySelector(".price-popup .calculate-price-popup-main");
        const popupWrapper = document.querySelector(".price-popup.calculate-price-popup");

        if (popup) {
          popup.style.opacity = "0";
          popupWrapper.classList.remove("active");

          setTimeout(() => {
            popup.style.display = "none";
          }, 200);
        }

        const popupHideDays = window.theme?.settings?.popup_hide_days || 1;
        let date = new Date();
        date.setDate(date.getDate() + popupHideDays);
        localStorage.setItem("popup_closed", date.toISOString());

      });
    }
  }

  calculatePricePopup();

  // ---- Free Audit Popup Start ----

  function freeAuditPopup() {
    const popupWrapper = document.querySelector(".free-audit-popup.calculate-price-popup");
    const popup = document.querySelector(".free-audit-popup .calculate-price-popup-main");
    const closeButtons = document.querySelectorAll(".free-audit-popup .close-popup, .free-audit-popup .overlay");
    const openButton = document.querySelector(".free-audit-popup-fixed-btn .button");

    if (!popupWrapper || !popup) return;

    const hideDays = window.theme?.settings?.audit_popup_hide_days || 1;

    /* ----------------------- Helper Functions ----------------------- */

    function openPopup() {
      popup.style.opacity = "0";
      popup.style.display = "block";
      popupWrapper.classList.add("active");

      setTimeout(() => {
        popup.style.opacity = "1";
      }, 200);
    }

    function closePopup() {
      popup.style.opacity = "0";
      popupWrapper.classList.remove("active");

      setTimeout(() => {
        popup.style.display = "none";
      }, 200);
    }

    /* ----------------------- Auto show popup ----------------------- */

    setTimeout(() => {
      const popupClosedDate = localStorage.getItem("audit_popup_closed");

      if (!popupClosedDate || new Date() > new Date(popupClosedDate)) {
        openPopup();
      }
    }, 6000);

    /* ----------------------- Manual open (IGNORE localStorage) ----------------------- */

    if (openButton) {
      openButton.addEventListener("click", function () {
        openPopup();
      });
    }

    /* ----------------------- Close popup (KEEP localStorage) ----------------------- */

    if (closeButtons.length) {
      closeButtons.forEach((btn) => {
        btn.addEventListener("click", function () {
          closePopup();

          let auditDate = new Date();
          auditDate.setDate(auditDate.getDate() + hideDays);
          localStorage.setItem("audit_popup_closed", auditDate.toISOString());
        });
      });
    }
  }

  freeAuditPopup();

  document.addEventListener("DOMContentLoaded", function () {
    const auditBtnWrapper = document.querySelector(".free-audit-popup-fixed-btn");
    const closeBtn = document.querySelector(".free-audit-popup-fixed-btn .close-btn");

    if (!auditBtnWrapper) return;

    setTimeout(() => {
      auditBtnWrapper.classList.add("is-visible");
    }, 3000);

    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        auditBtnWrapper.classList.remove("is-visible");
      });
    }
  });

  // ---- Free Audit Popup End ----

  
//FILLTER BUTTON

let btnTags = document.querySelectorAll(".btn-tags.btn-filter");
btnTags.forEach((btnTags) => {
    gsap.from(btnTags, {
        duration: 2,
        scale: 0.8,
        opacity: 0,
        delay: 0,
        stagger: 0.2,
        ease: "elastic",
        force3D: true,
        scrollTrigger: {
            trigger: btnTags,
            start: "top 80%"
        }
    });
});

//CountUp
const countItem = document.querySelectorAll(".count");
countItem.forEach((countItem) => {
    gsap.from(countItem, {
        textContent: 0,
        duration: 4,
        ease: "power1.in",
        snap: { textContent: 1 },
        stagger: {
            onUpdate: function () {
                this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].textContent));
            }
        },
        scrollTrigger: {
            trigger: countItem,
            start: "top 90%",
            end: "top 5%"
        }
    });
});
function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}




})();

const obj = document.querySelector(".enable-swaying-cards");
if(obj){
(function () {
    window.onload = () => {
		const time = 10000;
		function animStart() {
			if (obj.classList.contains("active") == false) {
				obj.classList.add("active");
              const body = document.body;
              body.style.overflow = "auto";
				setTimeout(() => {
					animEnd();
				}, time);
			}
		}
        
		function animEnd() {
			obj.classList.remove("active");
			obj.offsetWidth;
		}
		document.addEventListener("scroll", function () {
			// scroll or scrollend
			animStart();
		});
		window.addEventListener("resize", animStart);
		animStart();
	};
})();

}

// popup book call 
function showbookPopup() {  
    document.getElementById("bookcallpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closebookPopup() {
    document.getElementById("bookcallpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}

function showformPopup() {  
    document.getElementById("formpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closeformPopup() {
    document.getElementById("formpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


function showwhitelablepricingPopup() {  
    document.getElementById("whitelablepopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closewhitelablepricingPopup() {
    document.getElementById("whitelablepopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}

function mainPopup() {  
    document.getElementById("mainpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closemainPopup() {
    document.getElementById("mainpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}

function openFormPopup(event) {
    const triggeredButton = event.currentTarget || event.target;
    const selectors = [
        '.pricing-plan',
        '.landing-offer-section',
        '.pilot-section',
        '.mv-custom_section',
        '.section-custom-image-text',
        '.image-with-text__content',
        '.hero-inner-page'
    ];

    for (const selector of selectors) {
        const parent = triggeredButton.closest(selector);
        const popup = parent?.querySelector('.popup-form');
        if (popup) {
            if (event && typeof event.preventDefault === 'function') {
                event.preventDefault();
            }
            popup.classList.add('show');
            document.documentElement.classList.add('overflow-hidden');
            break;
        }
    }
}


function closePopupForm(event) {
    const formElement = event.target.closest('.popup-form');
    if (formElement) {
        formElement.classList.remove('show');
        document.querySelector("html").classList.remove('overflow-hidden');
    }
}


// common popup
function showwcommonpopuppricingPopup() {  
    document.getElementById("commonpopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closecommonpricingPopup() {
    document.getElementById("commonpopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


function showwaffiliatepopuppricingPopup() {  
    document.getElementById("affiliatepopup").classList.add('show');
    document.querySelector("html").classList.add('overflow-hidden');
}
function closeaffiliatepricingPopup() {
    document.getElementById("affiliatepopup").classList.remove('show');
    document.querySelector("html").classList.remove('overflow-hidden');
}


// Price table tabs
const plan_tab_li = document.querySelectorAll(".plan_tab");
const pricing_data = document.querySelectorAll(".pricing-box h3");

plan_tab_li.forEach((li) => {
  li.addEventListener("click", (e) => {
    plan_tab_li.forEach((tab) => {
      tab.classList.remove("active");
    });
    e.currentTarget.classList.add("active");

    const clickedClassName = e.currentTarget.id;

    pricing_data.forEach((h3) => {
      h3.classList.remove("active");
    });
    pricing_data.forEach((h3) => {
      const h3Class = h3.getAttribute("class");
      if (h3Class == clickedClassName) {
        h3.classList.add("active");
      }
    });
  });
});

setTimeout(() => {
   var video = document.getElementById('myVideo');
    if(video){
     video.addEventListener('click', function() {
        if (video.muted) {
          video.muted = false; 
        } else {
          video.muted = true; 
        }
      });
    }
}, "2000");



let heroButtons = document.querySelectorAll('.hero-banner__action-group .button.scroll-price-section');

if(heroButtons) {
    heroButtons.forEach(function(heroButton) {
        heroButton.addEventListener("click", function() {
            const rootStyle = getComputedStyle(document.documentElement);
            const headerHeight = parseInt(rootStyle.getPropertyValue("--header-height")) || 0;
            const pricingSection = document.querySelector(".customers-pricing");
            if (pricingSection) {
                const scrollToPosition = pricingSection.offsetTop - headerHeight;
                window.scrollTo({
                    top: scrollToPosition,
                    behavior: "smooth"
                });
            }
        });
    });
}

gsap.utils.toArray("[data-bg-color]").forEach((section, i) => {
  if (section.getAttribute("data-bg-color") !== null) {
    var colorAttr = section.getAttribute("data-bg-color");

    gsap.to(".article-template", {
      backgroundColor:
        colorAttr === "dark"
          ? gsap.getProperty("html", "--dark")
          : gsap.getProperty("html", "--light"),
      color:
        colorAttr === "dark"
          ? gsap.getProperty("html", "--light")
          : gsap.getProperty("html", "--dark"),
      immediateRender: false,
      scrollTrigger: {
        trigger: section,
        scrub: true,
        start: "top bottom",
        end: "+=100%"
      }
    });
  }
});

const filter_item_main = document.querySelector('.reveal-text-cover');
const filter_items = filter_item_main?.querySelectorAll('.filter-item[data-category]');
if (filter_items) {
    filter_items.forEach(item=>{
        item.addEventListener('click',()=>{
        filter_items.forEach(active_item=>{
            active_item.classList.remove('filter-item--active');
        })
        item.classList.add('filter-item--active');
        })
        filter_items[0].classList.add('filter-item--active');
    });
}

let process1 = document.querySelector('.client-say-wrapper');
if ((typeof(process1) != 'undefined' && process1 != null)) {
  let sections = gsap.utils.toArray('.single-card');
  gsap.to(sections, {
    xPercent: -88 * (sections.length - 1),
    ease: "none",
    scrollTrigger: {
      start: "center center",
      pin: true,
      scrub: true,
      // end: "+=300",
      trigger: process1,
      markers: false,
      // pin: true,
      snap: 1 / (sections.length - 1),
      end: () => "+=" + document.querySelector(".client-say-wrapper").offsetWidth
    },
  });
}

let rotateLeftimage = document.querySelectorAll(".rotate-image-left");
rotateLeftimage.forEach((rotateLeftimage) => {
    gsap.to(rotateLeftimage, {
        x: -50,
        rotation: -35,
        duration: 2,
        scrollTrigger: {
            trigger: rotateLeftimage,
            scrub: 2
        }
    });
});

let rotateRightimage = document.querySelectorAll(".rotate-image-right");
rotateRightimage.forEach((rotateRightimage) => {
    gsap.to(rotateRightimage, {
        x: 50,
        rotation: 35,
        duration: 2,
        scrollTrigger: {
            trigger: rotateRightimage,
            scrub: 2
        }
    });
});

var quotesSlider = document.querySelector('.aud_quotes_slider');
if(quotesSlider) {
    var swiperOptions4 = {
         slidesPerView: 2,
        spaceBetween: 24,
        navigation: {
            nextEl: '.swiper-button-next1',
            prevEl: '.swiper-button-prev1',
        },
      breakpoints: {
        600: {
            slidesPerView: 1,
            spaceBetween: 10,
        }
      }
    };
    var swiper = new Swiper(".aud_quotes_slider", swiperOptions4);
}


document.addEventListener("DOMContentLoaded", function() {
  const readMoreBtn = document.querySelectorAll('.read-more-btn');

  readMoreBtn.forEach(function(button) {
    const content = button.previousElementSibling;
    const fullText = content.innerHTML.trim();
    const maxLength = 200;

    if (fullText.length > maxLength) {
      content.dataset.fullText = fullText;
      content.classList.add('truncated');

    } else {
      button.style.display = 'none';
    }

    button.addEventListener('click', function() {
      if (!content.classList.contains('expanded')) {
        content.classList.remove('truncated');
        content.classList.add('expanded');
        this.innerHTML = 'Read less';
      } else {
        content.classList.remove('expanded');
        content.classList.add('truncated');
        this.innerHTML = 'Read more';
      }
    });
  });
});

// Enhanced Service Menu with Popup and Animation
document.addEventListener("DOMContentLoaded", function() {
  // Service Menu Enhancement for Shopify Navigation
  const allMenuItems = document.querySelectorAll('a, summary');
  let serviceMenuLink = null;
  let serviceMenuDetails = null;
  let serviceMenuContent = null;
  
  // Helper: detect menu item title that matches the trigger text from admin settings
  function isServiceItemTitle(title) {
    if (!title) return false;
    const t = title.trim().toLowerCase();
    
    // Get trigger text from admin settings or fallback to "Service"
    const triggerText = (window.serviceMenuConfig && window.serviceMenuConfig.triggerText) || "Service";
    const triggerTextLower = triggerText.toLowerCase();
    
    return t === triggerTextLower;
  }

  // Ensure the service popup opens even if the link has a real URL
  // Intercepts early in the capture phase, prevents navigation,
  // creates dropdown if missing, then re-dispatches a safe click
  // so existing listeners open the menu.
  // (function attachServiceClickInterceptorOnce() {
  //   if (window.__serviceClickInterceptorAttached) return;
  //   window.__serviceClickInterceptorAttached = true;

  //   document.addEventListener(
  //     'click',
  //     function (e) {
  //       if (window.__serviceSyntheticClick) return; // avoid loops
  //       const target = e && e.target ? e.target : null;
  //       if (!target) return;

  //       const clickable = target.closest && target.closest('a, summary, button, [role="menuitem"]');
  //       if (!clickable) return;

  //       const labelText = (
  //         (clickable.textContent || clickable.innerText || '') +
  //         ' ' +
  //         (clickable.getAttribute && (clickable.getAttribute('aria-label') || ''))
  //       ).trim();

  //       if (!isServiceItemTitle(labelText)) return;

  //       // Stop navigation and let our menu open
  //       e.preventDefault();
  //       e.stopPropagation();

  //       try {
  //         // Create dropdown if it doesn't exist yet for this item
  //         const existingDropdown = clickable.closest('li') && clickable.closest('li').querySelector('.custom-service-dropdown');
  //         if (!existingDropdown && typeof createCustomServiceMenu === 'function') {
  //           createCustomServiceMenu(clickable);
  //         }

  //         // Re-dispatch a synthetic click that our existing listener will catch
  //         window.__serviceSyntheticClick = true;
  //         clickable.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  //       } finally {
  //         // Release the guard in the next tick to avoid recursion
  //         setTimeout(function () {
  //           window.__serviceSyntheticClick = false;
  //         }, 0);
  //       }
  //     },
  //     true // capture phase
  //   );
  // })();

  // Find the Services menu item (both links and summary elements)
  allMenuItems.forEach(item => {
    if (isServiceItemTitle(item.textContent)) {
      serviceMenuLink = item;
      serviceMenuDetails = item.closest('details.mega-menu');
      serviceMenuContent = serviceMenuDetails ? serviceMenuDetails.querySelector('.mega-menu__content') : null;
      
      // If no details element found, create a custom dropdown
      if (!serviceMenuDetails) {
        // console.log('Creating custom service menu dropdown for:', item);
        createCustomServiceMenu(item);
      }
    }
  });
  
  if (serviceMenuLink && serviceMenuDetails && serviceMenuContent) {
    const serviceMenuItem = serviceMenuLink.closest('li');
    
    // console.log('Enhanced Service Menu initialized successfully');
    
    // Add enhanced hover effects
    serviceMenuItem.addEventListener('mouseenter', function() {
      // console.log('Services menu hovered');
      
      // Open the details element
      serviceMenuDetails.open = true;
      
      // Add smooth animation classes
      serviceMenuContent.style.opacity = '0';
      serviceMenuContent.style.transform = 'translateY(-20px)';
      serviceMenuContent.style.display = 'block';
      
      // Animate in
      gsap.to(serviceMenuContent, {
        opacity: 1,
        y: 0,
        duration: 0.3,
        ease: "power2.out"
      });
      
      // Add backdrop blur effect
      const backdrop = document.createElement('div');
      backdrop.className = 'service-menu-backdrop';
      backdrop.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(2px);
        z-index: 998;
        opacity: 0;
      `;
      document.body.appendChild(backdrop);
      
      gsap.to(backdrop, {
        opacity: 1,
        duration: 0.3,
        ease: "power2.out"
      });
    });
    
    serviceMenuItem.addEventListener('mouseleave', function() {
      // Animate out
      gsap.to(serviceMenuContent, {
        opacity: 0,
        y: -20,
        duration: 0.2,
        ease: "power2.in",
        onComplete: function() {
          serviceMenuDetails.open = false;
        }
      });
      
      // Remove backdrop
      const backdrop = document.querySelector('.service-menu-backdrop');
      if (backdrop) {
        gsap.to(backdrop, {
          opacity: 0,
          duration: 0.2,
          ease: "power2.in",
          onComplete: function() {
            backdrop.remove();
          }
        });
      }
    });
    
    // Enhanced submenu items animation
    const submenuItems = serviceMenuContent.querySelectorAll('.service-menu-category, .service-menu-featured');
    submenuItems.forEach((item, index) => {
      item.style.opacity = '0';
      item.style.transform = 'translateX(-20px)';
      
      serviceMenuItem.addEventListener('mouseenter', function() {
        gsap.to(item, {
          opacity: 1,
          x: 0,
          duration: 0.4,
          delay: index * 0.05,
          ease: "power2.out"
        });
      });
    });
  } else {
    // console.log('Enhanced Service Menu not found, trying alternative approach...');
    
    // Alternative approach - look for any menu item with "Services" text
    const allMenuLinks = document.querySelectorAll('a, summary');
    allMenuLinks.forEach(link => {
      if (isServiceItemTitle(link.textContent)) {
        // console.log('Found Services menu item:', link);
        
        const parentDetails = link.closest('details');
        if (parentDetails) {
          const content = parentDetails.querySelector('.mega-menu__content');
          if (content) {
            // Add hover effect
            link.addEventListener('mouseenter', function() {
              parentDetails.open = true;
              content.style.display = 'block';
              content.style.opacity = '1';
            });
          }
        }
      }
    });
  }
  
  // ========================================
  // DYNAMIC SERVICE MENU CONFIGURATION
  // ========================================
  // 
  // This configuration is now loaded from Shopify admin settings
  // Go to: Customize Theme > Header > Dynamic Service Menu block
  // to modify the service menu settings
  //
  // ========================================
  
  // Function to get service menu configuration from Shopify settings
  function getServiceMenuConfig() {
    // Check if configuration is available from Shopify admin settings
    if (window.serviceMenuConfig) {
      // console.log('Using service menu configuration from Shopify admin settings');
      return window.serviceMenuConfig;
    }
    
    // Fallback to default configuration if no settings found
    // console.log('Using fallback service menu configuration');
    return {
      triggerText: "Service",
      categories: [
        {
          title: "Shopify Development",
          icon: "🛒",
          description: "Complete e-commerce solutions from setup to optimization",
          services: [
            { title: "Store Setup & Configuration", url: "/pages/our-pricing-page" },
            { title: "Shopify Plus Migration", url: "/pages/shopify-ecommerce-migration" },
            { title: "E-commerce Audit", url: "/pages/shopify-ecommerce-audits" },
            { title: "Theme Customization", url: "/pages/shopify-theme-customization" }
          ]
        },
        {
          title: "Industry Solutions",
          icon: "🏭",
          description: "Specialized solutions for your specific industry",
          service: [
            { title: "Cosmetic & Beauty", url: "/pages/cosmetic-industries" },
            { title: "Fashion & Apparel", url: "/pages/clothing-apparel" },
            { title: "Jewelry & Accessories", url: "/pages/jewellery" },
            { title: "Food & Beverages", url: "/pages/food-packets-and-beverages" },
            { title: "Fitness & Gym", url: "/pages/fitness-and-gym" },
            { title: "Watches", url: "/pages/watches" }
          ]
        },
        {
          title: "Landing & Marketing",
          icon: "📈",
          description: "Boost conversions and drive more sales",
          service: [
            { title: "Landing Page Design", url: "/pages/shopify-landing-page" },
            { title: "Advertorial Pages", url: "/pages/advertorial-pages" },
            { title: "Quick Shopify Setup", url: "/pages/quick-shopify-setup" },
            { title: "White Label Services", url: "/pages/white-label" }
          ]
        }
      ],
      featuredService: {
        badge: "FREE",
        title: "E-commerce Audit",
        description: "Get a comprehensive analysis of your online store performance and optimization recommendations", 
        buttonText: "Get Free Audit",
        buttonUrl: "/pages/contact"
      },
      footerCta: {
        title: "Ready to Grow Your Business?",
        subtitle: "India's #1 Shopify Plus Ecommerce Agency",
        buttonText: "Book A Call",
        buttonUrl: "/pages/contact"
      }
    };
  }
  
  // Get the service menu configuration
  const serviceMenuConfig = getServiceMenuConfig();

  // Function to generate dynamic HTML from configuration
  function generateServiceMenuHTML(config) {
    // Generate categories HTML
    const categoriesHTML = config.categories.map(category => `
      <div class="service-menu-category">
        <div class="service-category-icon">${category.icon}</div>
        <div class="service-category-content">
          <h4>${category.title}</h4>
          <p>${category.description}</p>
          <ul class="service-menu-list">
            ${category.service.map(service => `
              <li><a href="${service.url}">${service.title}</a></li>
            `).join('')}
          </ul>
        </div>
      </div>
    `).join('');

    // Generate featured service HTML
    const featuredHTML = `
      <div class="service-menu-featured">
        <div class="featured-service-card">
          <div class="featured-service-badge">${config.featuredService.badge}</div>
          <div class="featured-service-content">
            <h5>${config.featuredService.title}</h5>
            <p>${config.featuredService.description}</p>
            <a href="${config.featuredService.buttonUrl}" class="featured-service-btn">
              <span>${config.featuredService.buttonText}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    `;

    // Generate footer CTA HTML
    const footerHTML = `
      <div class="service-menu-footer">
        <div class="service-menu-cta">
          <div class="cta-content">
            <h5>${config.footerCta.title}</h5>
            <p>${config.footerCta.subtitle}</p>
          </div>
          <a href="${config.footerCta.buttonUrl}" class="service-cta-btn">
            <span>${config.footerCta.buttonText}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    `;

    return `
      <div class="service-menu-container">
        <div class="service-menu-close">
          <button class="close-btn" aria-label="Close menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div class="swipe-indicator">
          <div class="swipe-handle"></div>
          <span class="swipe-text">Swipe up to close</span>
        </div>
        
        <div class="service-menu-header">
          <h3>Our Services</h3>
          <p>Comprehensive Shopify solutions to grow your business</p>
        </div>
        
        <div class="service-menu-grid">
          ${categoriesHTML}
          ${featuredHTML}
        </div>
        
        ${footerHTML}
      </div>
    `;
  }

  // Function to create custom service menu dropdown
  function createCustomServiceMenu(serviceLink) {
  const serviceMenuItem = serviceLink.closest('li');
  if (!serviceMenuItem) {
    // console.log('No parent li found for service link');
    return;
  }

  // console.log('Creating dynamic service menu for:', serviceLink, 'Parent li:', serviceMenuItem);

  // Ensure parent li has proper positioning
  serviceMenuItem.style.position = 'relative';
  serviceMenuItem.style.zIndex = '1000';

  // Create the dropdown container with dynamic content
  const dropdown = document.createElement('div');
  dropdown.className = 'custom-service-dropdown';
  
  // Prefer Liquid snippet template if present, else fallback to JS-generated HTML
  (function applyTemplateOrDynamic() {
    const tpl = document.getElementById('service-menu-template');
    if (tpl && tpl.innerHTML && tpl.innerHTML.trim().length > 0) {
      dropdown.innerHTML = tpl.innerHTML;
    } else {
      dropdown.innerHTML = generateServiceMenuHTML(serviceMenuConfig);
    }
  })();

  // Ensure a visible close button exists
  if (!dropdown.querySelector('.close-btn')) {
    const closeWrap = document.createElement('div');
    closeWrap.className = 'service-menu-close';
    closeWrap.style.cssText = 'position:fixed;top:16px;right:16px;z-index:10000;';
    closeWrap.innerHTML = `
      <button class="close-btn" aria-label="Close menu" style="display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:20px;background:rgba(0,0,0,0.6);color:#fff;border:none;cursor:pointer;">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>`;
    dropdown.appendChild(closeWrap);
  }

  // Append dropdown
  serviceMenuItem.appendChild(dropdown);

  const closeBtn = dropdown.querySelector('.close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      gsap.to(closeBtn, {
        scale: 0.9,
        duration: 0.1,
        ease: "power2.out",
        onComplete: function() {
          gsap.to(closeBtn, { scale: 1, duration: 0.1, ease: "power2.out" });
        }
      });
      setTimeout(() => {
        closeServiceMenu();
      }, 100);
    });
  }

  let isMenuOpen = false;

  // Hide dropdown initially
  dropdown.style.display = 'none';
  dropdown.style.opacity = '0';
  dropdown.style.visibility = 'hidden';

  window.addEventListener('load', function() {
    dropdown.style.display = 'none';
    dropdown.style.opacity = '0';
    dropdown.style.visibility = 'hidden';
  });

  serviceMenuItem.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!isMenuOpen) openServiceMenu();
  });

  function openServiceMenu() {
    isMenuOpen = true;

    const backdrop = document.createElement('div');
    backdrop.className = 'service-menu-fullscreen-backdrop';
    backdrop.style.cssText = `position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.8); backdrop-filter: blur(8px); z-index: 9998; opacity: 0;`;
    document.body.appendChild(backdrop);

    dropdown.style.position = 'fixed';
    dropdown.style.top = '0';
    dropdown.style.left = '0';
    dropdown.style.width = '100%';
    dropdown.style.height = '100%';
    dropdown.style.transform = 'translateY(-100%)';
    dropdown.style.zIndex = '9999';
    dropdown.style.display = 'block';
    dropdown.style.visibility = 'visible';
    dropdown.style.opacity = '1';
    dropdown.style.borderRadius = '0';
    dropdown.style.marginTop = '0';
    dropdown.style.overflowY = 'auto';
    document.body.style.overflow = 'hidden';
    dropdown.offsetHeight;

    const cols = dropdown.querySelectorAll('.service-menu-category, .service-menu-featured');
    gsap.set(cols, { y: 20, opacity: 0, scale: 0.98 });

    const tl = gsap.timeline();
    tl.to(backdrop, { opacity: 1, duration: 0.4, ease: 'power2.out' }, 0)
      .to(dropdown, { y: '0%', duration: 0.7, ease: 'power3.out' }, 0)
      .to(cols, { y: 0, opacity: 1, scale: 1, duration: 0.5, ease: 'power2.out', stagger: 0.08 }, 0.2);

    dropdown.classList.add('service_active');

    // **NEW: Close menu on link click then redirect**
    const links = dropdown.querySelectorAll('a');
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const href = this.href;
        closeServiceMenu();
        // Wait animation to finish before redirect
        setTimeout(() => {
          window.location.href = href;
        }, 500); // matches close animation duration
      });
    });
  }

  function closeServiceMenu() {
    isMenuOpen = false;

    const cols = dropdown.querySelectorAll('.service-menu-category, .service-menu-featured');
    gsap.to(cols, { scale: 0.98, duration: 0.15, ease: 'power2.in' });

    gsap.to(dropdown, {
      y: '-100%',
      duration: 0.5,
      ease: 'power3.in',
      delay: 0.1,
      onComplete: function() {
        dropdown.style.visibility = 'hidden';
        dropdown.style.opacity = '0';
      }
    });

    const backdrop = document.querySelector('.service-menu-fullscreen-backdrop');
    if (backdrop) {
      gsap.to(backdrop, {
        opacity: 0,
        duration: 0.4,
        ease: "power2.in",
        delay: 0.05,
        onComplete: function() { backdrop.remove(); }
      });
    }

    dropdown.classList.remove('service_active');
    document.body.style.overflow = '';
  }

  // Disable backdrop and ESC close
  document.addEventListener('click', e => {
    if (isMenuOpen && e.target.classList.contains('service-menu-fullscreen-backdrop')) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
  document.addEventListener('keydown', e => {
    if (isMenuOpen && e.key === 'Escape') e.preventDefault();
  });
  
  // **Swipe gestures code remains exactly as before**
}
});

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".offer-button");
  const target = document.getElementById("customer-pricing");

  if (!target) return;

  buttons.forEach(button => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth" });
    });
  });
});


 function getStepHeight() {
    const elements = document.querySelectorAll('.process-step__desc');

    if (!elements.length) return;

    let maxHeight = 0;

    // sabki height lo
    elements.forEach(el => {
      el.style.height = 'auto'; // reset
      const h = el.offsetHeight;
      maxHeight = Math.max(maxHeight, h);
    });

    // sabko equal height do
    elements.forEach(el => {
      el.style.height = maxHeight + 'px';
    });

    // console.log('Max Height:', maxHeight);
  }

  // DOM ready
  window.addEventListener('DOMContentLoaded', getStepHeight);

  // Resize par
  window.addEventListener('resize', getStepHeight);


   function setStepTitleHeight() {
    const titles = document.querySelectorAll('.custom-process__steptitle');

    if (!titles.length) return;

    let maxHeight = 0;

    // reset + height calculate
    titles.forEach(title => {
      title.style.height = 'auto';
      const h = title.offsetHeight;
      maxHeight = Math.max(maxHeight, h);
    });

    // equal height apply
    titles.forEach(title => {
      title.style.height = maxHeight + 'px';
    });

    // console.log('Step Title Height:', maxHeight);
  }

  // page load
  window.addEventListener('DOMContentLoaded', setStepTitleHeight);

  // resize
  window.addEventListener('resize', setStepTitleHeight);


// ----- Readmore Functionality -------
document.addEventListener("DOMContentLoaded", function () {
  
  const wrappers = document.querySelectorAll(".mv-text-wrapper");
  wrappers.forEach(wrapper => {
    const setting = wrapper.dataset.readmore;
    const textBlock = wrapper.querySelector(".mv-text-block");
    const button = wrapper.querySelector(".mv-read-toggle");
    const isMobile = window.innerWidth <= 768;

    if (
      setting === "none" ||
      (setting === "desktop" && isMobile) ||
      (setting === "mobile" && !isMobile)
    ) {
      button.style.display = "none";
      return;
    }

    wrapper.classList.add("collapsed");

    let initialTop = 0;

    button.addEventListener("click", function () {
      if (wrapper.classList.contains("collapsed")) {
        initialTop = wrapper.getBoundingClientRect().top + window.scrollY;
        wrapper.classList.remove("collapsed");
        wrapper.classList.add("expanded");
        button.textContent = "Read Less";
      } else {
        wrapper.classList.remove("expanded");
        wrapper.classList.add("collapsed");
        button.textContent = "Read More";
      }
    });
  });
});

// ------- Header menu on hover --------
document.addEventListener('DOMContentLoaded', function() {
  // Function to close all menus
  function closeAllMenus() {
    document.querySelectorAll('.header-dropdown_menu').forEach(menu => {
      menu.removeAttribute('open');
      const menuItem = menu.querySelector('.header__menu-item');
      if (menuItem) {
        menuItem.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Handle parent menu items
  document.querySelectorAll('.header__menu-item').forEach(menuItem => {
    const parentMenu = menuItem.closest('.header-dropdown_menu');

    menuItem.addEventListener('mouseenter', () => {
      closeAllMenus();
      if (parentMenu) {
        parentMenu.setAttribute('open', '');
        menuItem.setAttribute('aria-expanded', 'true');
      }
    });

    menuItem.addEventListener('mouseleave', (e) => {
      const content = parentMenu?.querySelector('.header__submenu');
      if (!content?.contains(e.relatedTarget)) {
        if (parentMenu) {
          parentMenu.removeAttribute('open');
          menuItem.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  // Handle menu content areas
  document.querySelectorAll('.header__submenu').forEach(content => {
    content.addEventListener('mouseleave', (e) => {
      const parentMenu = content.closest('.header-dropdown_menu');
      if (parentMenu && !parentMenu.contains(e.relatedTarget)) {
        parentMenu.removeAttribute('open');
        const menuItem = parentMenu.querySelector('.header__menu-item');
        if (menuItem) {
          menuItem.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });
});


(() => {
  function setHomeHeroOffset() {
    if (!document.body) return;

    const isHomePage = document.body.classList.contains('index');
    if (!isHomePage) {
      document.documentElement.style.setProperty('--home-hero-neg-top', '0px');
      return;
    }

    const hero = document.querySelector('.custom_hero_banner_media_wrapper');
    if (!hero) return;

    const selectors = [
      '.new-announcement-bar',
      '.announcement-bar-section',
      '.header-wrapper',
      '.section-header'
    ];

    let total = 0;

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!el || el.offsetParent === null) return;
        total += el.getBoundingClientRect().height || 0;
      });
    });

    document.documentElement.style.setProperty('--home-hero-neg-top', total + 'px');
  }

  if (typeof window === 'undefined') return;

  window.addEventListener('load', setHomeHeroOffset);
  window.addEventListener('resize', setHomeHeroOffset);
  window.addEventListener('scroll', setHomeHeroOffset, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    const observed = Array.from(document.querySelectorAll('.new-announcement-bar, .announcement-bar-section, .header-wrapper, .section-header'));
    if (observed.length) {
      const observer = new ResizeObserver(() => setHomeHeroOffset());
      observed.forEach((el) => observer.observe(el));
    }
  }

  setHomeHeroOffset();
})();



(function () {
  var POPUP_TRANSITION_MS = 400;

  function portalDeepDivesPopup(popup) {
    if (popup.parentElement !== document.body) {
      popup._portalParent = popup.parentElement;
      popup._portalNext = popup.nextSibling;
      document.body.appendChild(popup);
    }
  }

  function restoreDeepDivesPopup(popup) {
    if (!popup._portalParent) return;

    if (popup._portalNext && popup._portalNext.parentNode === popup._portalParent) {
      popup._portalParent.insertBefore(popup, popup._portalNext);
    } else {
      popup._portalParent.appendChild(popup);
    }
  }

  window.openDeepDivesPopup = function (popup) {
    if (!popup || popup.classList.contains('active')) return;

    portalDeepDivesPopup(popup);
    document.body.style.overflow = 'hidden';

    popup.classList.remove('active', 'is-closing');
    void popup.offsetWidth;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add('active');
      });
    });
  };

  window.closeDeepDivesPopup = function (popup) {
    if (!popup || !popup.classList.contains('active') || popup.classList.contains('is-closing')) return;

    popup.classList.add('is-closing');
    popup.classList.remove('active');

    window.setTimeout(function () {
      popup.classList.remove('is-closing');
      document.body.style.overflow = '';
      restoreDeepDivesPopup(popup);
    }, POPUP_TRANSITION_MS);
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  const openButtons = document.querySelectorAll('.technical-taxonomy__card .open-popup');

  openButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      const card = this.closest('.technical-taxonomy__card');
      if (!card) return;

      const popup = card.querySelector('.deep-dives-left-items-popup');
      if (popup) {
        window.openDeepDivesPopup(popup);
      }
    });
  });

  const closeButtons = document.querySelectorAll('.deep-dives-left-items-popup-close');
  closeButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.stopPropagation();
      const popup = this.closest('.deep-dives-left-items-popup');
      if (popup) {
        window.closeDeepDivesPopup(popup);
      }
    });
  });

  document.addEventListener('click', function (event) {
    const activePopups = document.querySelectorAll('.deep-dives-left-items-popup.active');
    activePopups.forEach(function (popup) {
      const popupInner = popup.querySelector('.deep-dives-left-items-popup-inner');

      if (popupInner && !popupInner.contains(event.target) && !event.target.closest('.open-popup')) {
        window.closeDeepDivesPopup(popup);
      }
    });
  });
});


 var chatbot_openers = document.querySelectorAll('.js-open-chatbox');
  if(chatbot_openers.length > 0) {
    chatbot_openers.forEach(opener=>{
      opener.addEventListener('click', ()=>{
        TriggerChatBot();
      })
    })
  }

  function TriggerChatBot(){
    var chatbot = document.querySelector('shopify-chat');
    if(chatbot){
      var chatBotShadowRoot = chatbot.shadowRoot;
      if(chatBotShadowRoot) {
        var chatBotTrigger = chatBotShadowRoot.querySelector('button[part="activator"]');
        if(chatBotTrigger){
          setTimeout(()=>{
            chatBotTrigger.click();
          }, 100);
        } else {
          var innerChatBotFinder = chatBotShadowRoot.querySelector('shopify-agent-runtime');
          if(innerChatBotFinder)
            var innerChatBotShadowRoot = innerChatBotFinder.shadowRoot;
            if(innerChatBotShadowRoot){
              var innerChatBotTrigger = innerChatBotShadowRoot.querySelector('button[part="activator"]');
              if(innerChatBotTrigger){
                setTimeout(()=>{
                  innerChatBotTrigger.click();
                }, 100);
              }
            }
        }
      }
    }
  }

    const all_device_tab_buttons = document.querySelectorAll('.device-tab-button');
  if(all_device_tab_buttons.length > 0) {
    all_device_tab_buttons.forEach(tab=>{
      tab.addEventListener('click', ()=>{
        updateDevicetab(tab);
      })
    })
  }

  function updateDevicetab(tab) {
    const closest_multirow_wrapper = tab.closest('.multirow__inner');
    if(closest_multirow_wrapper){
      const tab_view = tab.getAttribute('data-view');
      const getAllTabElements = closest_multirow_wrapper.querySelectorAll(`.image-with-text`);
      const getAllSelectedTabElements = closest_multirow_wrapper.querySelectorAll(`.${tab_view}-list`);
      if(getAllTabElements.length > 0){
        getAllTabElements.forEach(ele=>{
          ele.classList.add('hidden');
        })
      }
      if(getAllSelectedTabElements.length > 0){
        getAllSelectedTabElements.forEach(ele=>{
          if(ele.classList.contains('hidden')) ele.classList.remove('hidden');
        })
      }
    }
  }



document.addEventListener('DOMContentLoaded', function () {
  const footerGroup = document.querySelector('.shopify-section-group-footer-group');

  if (!footerGroup) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          footerGroup.classList.add('hidden-chat__icon');
        } else {
          footerGroup.classList.remove('hidden-chat__icon');
        }
      });
    },
    {
      threshold: 0
    }
  );

  observer.observe(footerGroup);
});
